import { render, staticRenderFns } from "./SimpleGridDialogColumn.vue?vue&type=template&id=6456c660&scoped=true"
import script from "./SimpleGridDialogColumn.vue?vue&type=script&lang=js"
export * from "./SimpleGridDialogColumn.vue?vue&type=script&lang=js"
import style0 from "./SimpleGridDialogColumn.vue?vue&type=style&index=0&id=6456c660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456c660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
